import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa6";
import "./Header.css";

const PRODUCT_ITEMS = [
  {
    id: "insurance",
    title: "Insurance",
    desc: "Underwriting & claims intelligence for regulated insurers",
    to: "/ProductInsurance",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path d="M9.5 12.2l1.8 1.8 3.4-3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    iconClass: "is-insurance",
  },
  {
    id: "finance",
    title: "Finance",
    desc: "Risk and compliance intelligence for financial institutions",
    soon: true,
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 3 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    ),
    iconClass: "is-finance",
  },
  {
    id: "intelligence",
    title: "Intelligence",
    desc: "The core enterprise intelligence layer, across every vertical",
    to: "/ProductIntelligence",
    icon: <span className="nav-mega__ai">AI</span>,
    iconClass: "is-intelligence",
  },
  {
    id: "healthcare",
    title: "Healthcare",
    desc: "Clinical and operational intelligence for healthcare systems",
    soon: true,
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 20s-7-4.4-7-10a4 4 0 017-2.5A4 4 0 0119 10c0 5.6-7 10-7 10z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
    ),
    iconClass: "is-healthcare",
  },
];

const DISCOVER_ITEMS = [
  {
    id: "insurance",
    title: "Insurance",
    href: "https://insurance.highwatch.ai/login",
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path d="M9.5 12.2l1.8 1.8 3.4-3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: "intelligence",
    title: "Intelligence",
    href: "https://intelligence.highwatch.ai/login",
    icon: <span className="header-discover__ai">AI</span>,
  },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [discoverOpen, setDiscoverOpen] = useState(false);
  const location = useLocation();

  const closeMobileMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header-top">
        <Link to="/" className="logo-link" aria-label="Highwatch AI Home">
          <img
            src="/icons/Highwatch_logo.svg"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/icons/Highwatch_logo.svg";
            }}
            alt="Highwatch AI"
            className="logo-img"
          />
        </Link>

        <nav className="nav-links nav-links--legacy">
          <Link to="/ProductInsurance">Product</Link>
          <Link to="/Solutions">Use Cases</Link>
          <Link to="/AboutUs">About Us</Link>
          <Link to="/Pricing">Pricing</Link>
          <Link to="/Contact">Contact</Link>
        </nav>

        <nav className="nav-links nav-links--figma">
          <div
            className="nav-dropdown"
            onMouseEnter={() => setProductsOpen(true)}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <button
              type="button"
              className="nav-dropdown__trigger"
              aria-expanded={productsOpen}
              onClick={() => setProductsOpen((value) => !value)}
            >
              Products <span aria-hidden="true">▾</span>
            </button>
            {productsOpen && (
              <div className="nav-mega">
                <div className="nav-mega__panel">
                  <div className="nav-mega__grid">
                    {PRODUCT_ITEMS.map((item) => {
                      const active = item.to && location.pathname === item.to;
                      const className = `nav-mega__item ${item.iconClass} ${
                        active ? "is-active" : ""
                      } ${item.soon ? "is-soon" : ""}`;

                      const content = (
                        <>
                          <span className="nav-mega__icon" aria-hidden="true">
                            {item.icon}
                          </span>
                          <span className="nav-mega__text">
                            <strong>
                              {item.title}
                              {item.soon && <em>COMING SOON</em>}
                            </strong>
                            <span>{item.desc}</span>
                          </span>
                        </>
                      );

                      if (item.soon) {
                        return (
                          <div key={item.id} className={className}>
                            {content}
                          </div>
                        );
                      }

                      return (
                        <Link
                          key={item.id}
                          className={className}
                          to={item.to}
                          onClick={() => setProductsOpen(false)}
                        >
                          {content}
                        </Link>
                      );
                    })}
                  </div>
                  <div className="nav-mega__footer">
                    <Link to="/Contact" onClick={() => setProductsOpen(false)}>
                      Don&apos;t see your industry yet?{" "}
                      <strong>Talk to us about your use case →</strong>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Link to="/Solutions">Solutions</Link>
          <Link to="/AboutUs">About Us</Link>
          <Link to="/Pricing">Pricing</Link>
          <Link to="/Contact">Contact</Link>
        </nav>

        <div className="header-right">
          <Link
            to="/ProductIntelligence"
            className="login-btn desktop-btn header-cta--legacy"
          >
            Intelligence
          </Link>
          <Link to="/Contact" className="login-btn desktop-btn header-cta--legacy">
            Discover Highwatch →
          </Link>

          <div
            className="header-discover"
            onMouseEnter={() => setDiscoverOpen(true)}
            onMouseLeave={() => setDiscoverOpen(false)}
          >
            <button
              type="button"
              className="header-btn header-btn--ghost header-cta--figma"
              aria-expanded={discoverOpen}
              onClick={() => setDiscoverOpen((value) => !value)}
            >
              Discover Highwatch <span aria-hidden="true">▾</span>
            </button>
            {discoverOpen && (
              <div className="header-discover__dropdown">
                <div className="header-discover__menu">
                  {DISCOVER_ITEMS.map((item) => (
                    <a
                      key={item.id}
                      href={item.href}
                      className="header-discover__item"
                      onClick={() => setDiscoverOpen(false)}
                    >
                      <span className="header-discover__icon" aria-hidden="true">
                        {item.icon}
                      </span>
                      <span>{item.title}</span>
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Link to="/Contact" className="header-btn header-btn--primary header-cta--figma">
            Get a demo <span aria-hidden="true">▾</span>
          </Link>

          <Link to="/ProductIntelligence" className="login-btn mobile-btn">
            Intel
          </Link>
          <Link to="/Contact" className="login-btn mobile-btn">
            Demo
          </Link>

          <button
            type="button"
            className="menu-icon"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMenuOpen((value) => !value)}
          >
            <FaBars />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="mobile-menu" aria-label="Mobile navigation">
          <Link to="/ProductInsurance" onClick={closeMobileMenu}>
            Product Insurance
          </Link>
          <Link to="/ProductIntelligence" onClick={closeMobileMenu}>
            Intelligence
          </Link>
          <Link to="/Solutions" onClick={closeMobileMenu}>
            Solutions
          </Link>
          <Link to="/AboutUs" onClick={closeMobileMenu}>
            About Us
          </Link>
          <Link to="/Pricing" onClick={closeMobileMenu}>
            Pricing
          </Link>
          <Link to="/Contact" onClick={closeMobileMenu}>
            Contact
          </Link>
        </nav>
      )}
    </header>
  );
}
